module.exports = __webpack_public_path__ + "static/media/img2.348fae37.png";